<template>
  <div class="flex flex-col gap-1">
    <label v-if="label" :for="props.name" :class="labelClasses">{{ label }}</label>
    <div class="flex flex-wrap gap-4">
      <div v-for="(option, index) in props.options" class="flex items-center h-8">
        <RadioButton v-model="value" :inputId="props.name + index" :name="props.name" :value="option" @change="handleChange" />
        <label :for="props.name + index" class="font-bold ml-2">{{ option }}</label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  options: any[];
  onChange?: Function;
  label?: string;
  labelClasses?: string;
}
const props = withDefaults(defineProps<Props>(), {
  labelClasses: "font-bold",
});

const handleChange = (): void => {
  if (props.onChange) props.onChange();
};

const { value, errorMessage } = useField(() => props.name);
</script>
